var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueNumberFormat',{staticClass:"form-control",attrs:{"options":_vm.fieldOptions,"disabled":_vm.isDisable},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }